export const apikey= 'fb77e70d05msh3e19fe112808da5p15d508jsna481a122fd4f';
export const openAIkey= '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';